/* Carrusel con rebote de la galería del producto.
   Patrón documentado en la skill cro-landing-cod (references/carrusel-rebote.md):
   la galería es la posición 0 y, si el cliente no desliza, se pierde todos los
   argumentos menos el primero. Esto avisa de que hay más fotos sin robarle la
   foto a quien está mirando.

   Las 6 decisiones que lo hacen funcionar, cada una nacida de un fallo real:
   1. Rebote por transform, NO por scroll: el carrusel usa scroll-snap mandatory
      y descarta cualquier desplazamiento parcial.
   2. Asoma y vuelve; nunca cambia de foto sola.
   3. Filtra eventos sintéticos con isTrusted: el slider del tema emite eventos
      propios al arrancar y apagaban la animación antes de que nadie tocara nada.
   4. IntersectionObserver al 40%: no anima si la galería no está en pantalla.
   5. Tres vueltas y se calla. Un bucle infinito compite con el CTA.
   6. Respeta prefers-reduced-motion y document.hidden.

   Se activa solo si hay 2 o más fotos. */
(function () {
  if (window.__lvRebote) return;
  window.__lvRebote = 1;

  var CSS = [
    '.product__media-wrapper{position:relative}',
    '.lv-swipe{position:absolute;left:50%;bottom:-13px;transform:translateX(-50%);',
    'z-index:3;display:flex;align-items:center;gap:8px;padding:8px 14px;',
    'border-radius:999px;background:rgba(4,20,12,.78);color:#fff;font-size:12px;',
    'font-weight:700;white-space:nowrap;opacity:0;transition:opacity .45s ease;',
    'pointer-events:none}',
    '.lv-swipe.on{opacity:1}',
    '.lv-swipe i{display:inline-block;font-style:normal;font-size:15px;',
    'animation:lvslide 1.4s ease-in-out infinite}',
    '@keyframes lvslide{0%,100%{transform:translateX(-4px)}50%{transform:translateX(4px)}}',
    '.product__media-list>li{transition:transform .42s cubic-bezier(.34,1.12,.5,1)!important}',
    '.product__media-list.lv-asoma>li{transform:translateX(-16px)!important}'
  ].join('');

  function init() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var slides = list.children;
    if (slides.length < 2) return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var parado = false, timer = null, hint = null;
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var wrap = document.querySelector('.product__media-wrapper');
    if (wrap) {
      hint = document.createElement('div');
      hint.className = 'lv-swipe';
      hint.innerHTML = '<i>&#8250;&#8250;</i> Desliza para ver las ' + slides.length + ' fotos';
      wrap.appendChild(hint);
      setTimeout(function () { if (!parado && hint) hint.classList.add('on'); }, 1400);
      setTimeout(function () { if (hint) hint.classList.remove('on'); }, 9000);
    }

    function scrollable() { return list.scrollWidth - list.clientWidth > 10; }

    function rebote() {
      if (parado || document.hidden || !scrollable()) return;
      list.classList.add('lv-asoma');
      setTimeout(function () { list.classList.remove('lv-asoma'); }, 460);
    }

    function parar(e) {
      if (e && e.isTrusted === false) return;
      if (parado) return;
      parado = true;
      if (timer) { clearInterval(timer); timer = null; }
      if (hint) hint.classList.remove('on');
      list.classList.remove('lv-asoma');
    }

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      list.addEventListener(ev, parar, { passive: true });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest(
        '.slider-button, .slider-counter__link, .thumbnail, .product__media-toggle')) parar();
    });

    if (!reduce && 'IntersectionObserver' in window) {
      var vueltas = 0;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (x) {
          if (x.isIntersecting && !parado && !timer) {
            timer = setInterval(function () {
              if (parado || vueltas >= 3) { clearInterval(timer); timer = null; return; }
              vueltas++;
              rebote();
            }, 3200);
          } else if (!x.isIntersecting && timer) {
            clearInterval(timer);
            timer = null;
          }
        });
      }, { threshold: 0.4 }).observe(list);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
